import { render, staticRenderFns } from "./Proponents.vue?vue&type=template&id=816540ec&scoped=true"
import script from "./Proponents.vue?vue&type=script&lang=js"
export * from "./Proponents.vue?vue&type=script&lang=js"
import style0 from "./Proponents.vue?vue&type=style&index=0&id=816540ec&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816540ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('816540ec')) {
      api.createRecord('816540ec', component.options)
    } else {
      api.reload('816540ec', component.options)
    }
    module.hot.accept("./Proponents.vue?vue&type=template&id=816540ec&scoped=true", function () {
      api.rerender('816540ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/bidDocumentation/components/Proponents.vue"
export default component.exports